import type { ReactNode, HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

interface JarvisCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function JarvisCard({ className, children, ...rest }: JarvisCardProps) {
  return (
    <div
      className={cn(
        'bg-jarvis-surface border border-jarvis-border rounded-xl p-5',
        'shadow-[0_0_0_1px_rgba(255,255,255,0.02)]',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
